import { ChartModel, CurrentUsageRequestModel } from './../../../models/azure-dashboard-view.model';
import { Chart, registerables } from 'chart.js';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TenantDailyResourceUsage } from '../../../models/azure-dashboard-view.model';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportingService } from '../../../services/reporting.service';
import { NgProgress } from 'ngx-progressbar';
import { Sort } from '@angular/material/sort';
import { NgProgressService } from '../../../services/ngProgress.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-azure-current-usage-details',
  templateUrl: './azure-current-usage-details.component.html',
  styleUrls: ['./azure-current-usage-details.component.css']
})
export class AzureCurrentUsageDetailsComponent implements OnInit {
  @ViewChild('chartDailyTenantUsageCategory') chartDailyTenantUsageCategory: ElementRef;
  @ViewChild('chartDailyTenantUsage') chartDailyTenantUsage: ElementRef;
  
  title = 'Current Usage Details';

  searchField = '';
  subscriptionName = '';

  tenantDailyResourceUsage: TenantDailyResourceUsage[] = [];
  sortedData: TenantDailyResourceUsage[] = [];
  tenantUsagecategoryChartData: ChartModel[] = [];
  tenantUsagecategoryChartLabels: string[] = [];
  tenantUsagecategoryChartValues: string[] = [];
  dailyTenantUsageChartData: ChartModel[] = [];
  dailyTenantUsageChartLabels: string[] = [];
  dailyTenantUsageDataSet: any[] = [];
  requestModel: CurrentUsageRequestModel = <CurrentUsageRequestModel>{};

  loadContent = false;

  //charts
  lineChart: any;
  doughnutChart: any;

  //params
  tenantId: string = '';
  subscriptionId: string = '';
  lastBillingDate: string = '';
  nextBillingDate: string = '';

  //unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  backgroundColors: string[] = [
    '#C20047',
    '#437EB4',
    '#fef77b',
    '#660066',
    '#800000',
    '#E1FCFF',
    '#ffc500',
    '#84BF84',
    '#F08080',
    '#0E6655',
    '#ff33ff',
    '#86b300',
    '#4d0099',
    '#00cc99',
    '#ff704d',
    '#0000b3',
    '#66a3ff',
    '#ffcc80',
    '#7575a3',
    '#408000',
    '#00ff99',
    '#b32d00',
    '#ff0066',
    '#4db8ff',
    '#ffff80',
    '#cc0000',
    '#8080ff'
  ];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private reportingService: ReportingService,
    public ngProgress: NgProgressService
  ) { 
    Chart.register(...registerables);
  }

  ngOnInit() {
    this.ngProgress.start();

    this.activatedRoute.queryParamMap.subscribe(param => {
        this.tenantId = param.get('tenantId');
        this.subscriptionId = param.get('subscriptionId');
        this.lastBillingDate = param.get('lastBillingDate');
        this.nextBillingDate = param.get('nextBillingDate');
        this.subscriptionName = param.get('subscriptionName');
        
        this.requestModel.tenantId = this.tenantId;
        this.requestModel.subscriptionId = this.subscriptionId;
        this.requestModel.lastBillingDate = this.lastBillingDate;
        this.requestModel.nextBillingDate = this.nextBillingDate;

        $('.combination-loader').animate(
          { scrollLeft: ( 1240 ) },
          {
            duration: 400,
            complete: function(){
              
              $('.combination-loader').stop(true,false);
            }
        });

        this.getTenantCurrentResourceList();
        //this.getDailyTenantUsage();
        //this.getDailyTenantUsageCategory();

    });

    this.ngProgress.done();
  }

  getTenantCurrentResourceList():void {
    this.reportingService.getTenantCurrentResourceList(this.requestModel).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((values:TenantDailyResourceUsage[]) => {
        this.tenantDailyResourceUsage = values;
        this.sortedData = this.tenantDailyResourceUsage.slice();
    },
    (error: any) => {
      console.info(error);
      this.ngProgress.done();
    });
  }

  getDailyTenantUsageCategory():void {

    this.reportingService.getDailyTenantUsageCategory(this.requestModel).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: ChartModel[]) => {
          this.tenantUsagecategoryChartData = value;

          if(this.tenantUsagecategoryChartData.length) {
            this.tenantUsagecategoryChartData.forEach(i => {
              this.tenantUsagecategoryChartLabels.push(i.name);
              this.tenantUsagecategoryChartValues.push(i.value);
            });
          }

          const title = `CURRENT USAGE AMOUNT BY CATEGORY`;
      this.initializeDoughnutChart(this.chartDailyTenantUsageCategory,title, this.tenantUsagecategoryChartLabels, this.tenantUsagecategoryChartValues);
      },
      (error:any) => {
        console.info(error);
        this.ngProgress.done();
      });
  }

  getDailyTenantUsage():void {

    this.reportingService.getDailyTenantUsage(this.requestModel).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((values: ChartModel[]) => {
       this.dailyTenantUsageChartData = values;
       
       if (this.dailyTenantUsageChartData.length) {
         let currentUsageTotalArray = [];
         let unConfirmedTotallArray = [];
         let estimatedUsageTotalArray = [];

         currentUsageTotalArray = this.dailyTenantUsageChartData.filter(x => x.name === 'CurrentUsageTotal');
         unConfirmedTotallArray = this.dailyTenantUsageChartData.filter(x => x.name === 'UnConfirmedTotal');
         estimatedUsageTotalArray = this.dailyTenantUsageChartData.filter(x => x.name === 'EstimatedUsageTotal');

         //labels array
         this.dailyTenantUsageChartLabels = currentUsageTotalArray.map(x => x.date);
         //sort by date ascending
         this.dailyTenantUsageChartLabels.sort((a,b) => a > b ? 1 : -1);
         currentUsageTotalArray.sort((a,b) => a.date > b.date ? 1 : -1);
         unConfirmedTotallArray.sort((a,b) => a.date > b.date ? 1 : -1);
         estimatedUsageTotalArray.sort((a,b) => a.date > b.date ? 1 : -1);

         this.dailyTenantUsageDataSet.push({
           label: 'Confirmed',
           data: currentUsageTotalArray.map(x => x.value),
           borderColor: '#C20047',
           backgroundColor: '#C20047',
           fill: false
         });

         this.dailyTenantUsageDataSet.push({
          label: 'Un-Confirmed',
          data: unConfirmedTotallArray.map(x => x.value),
          borderColor: '#FFD1D1',
          backgroundColor: '#FFD1D1',
          fill: false
        });

        this.dailyTenantUsageDataSet.push({
          label: 'Estimated',
          data: estimatedUsageTotalArray.map(x => x.value),
          borderColor: '#FFD1G9',
          backgroundColor: '#FFD1G9',
          fill: false
        });

        const title = 'CURRENT USAGE AMOUNT - DAILY';
        this.initializeLineChart(this.chartDailyTenantUsage, title, this.dailyTenantUsageChartLabels, this.dailyTenantUsageDataSet);
       }
    },
      (error:any) => {
        console.info(error);
        this.ngProgress.done();
      })
  }

  initializeDoughnutChart(chart: ElementRef, title: string, labels: string[], values: string[]) {
    const ctx = chart.nativeElement;

    this.doughnutChart = new Chart(ctx, {
      type: 'doughnut',
			data: {
				datasets: [{
					data: values,
          backgroundColor: this.backgroundColors
				}],
				labels: labels
			},
			options: {
				responsive: true,
        plugins: {
          legend: {
            position: 'top',
            display: false
          },
          title: {
            display: true,
            text: title
          }
        },
				animation: {
					animateScale: true,
					animateRotate: true
				}
			}
    });
  }

  initializeLineChart(chart: ElementRef, title: string, labels: string[], dataset: any) {
    const ctx = chart.nativeElement;

    this.lineChart = new Chart(ctx, {
      type: 'line',
			data: {
				datasets: dataset,
				labels: labels
			},
      options: {
        responsive: true,
        plugins: {
          title: {
            display: true,
            text: title
          },
          tooltip: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label: function (tooltipItem) {
                return tooltipItem.formattedValue.toLocaleString();
              }
            }
          },
          legend: {
            display: true,
            position: 'top',
            labels: {
              padding: 30,
              usePointStyle: true,
            }
          },
        },     
        hover: {
          mode: 'nearest',
          intersect: true,
        },  
        scales: {
          xAxes: {
            display: true,
            // gridLines: false,
            ticks: {
              padding: 7,
              font: {
                size: 10,
                style: 'normal'
              }
            }
          },
          yAxes: {
            display: true,
            // gridLines: {
            //   borderDash: [4, 4]
            // },
            ticks: {
              callback: function (label, index, labels) {
                return label.toLocaleString();
              },
              padding: 5,
              font: {
                size: 10,
                style: 'normal'
              }
            }
          },
        }
      }
    });
  }

  onLoading(currentLoadingStatus: boolean) {
   
    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy() {
    
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  close() {

    this.router.navigateByUrl('/reporting/azurereportingdashboard');
  }
  
  sortData(sort: Sort) {
    const data = this.tenantDailyResourceUsage.slice();

    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'category': return compare(a.category.toLowerCase(), b.category.toLowerCase(), isAsc);
        case 'subCategory': return compare(a.subCategory.toLowerCase(), b.subCategory.toLowerCase(), isAsc);
        case 'usageStartDate': return compare(a.usageStartDate.toLowerCase(), b.usageStartDate.toLowerCase(), isAsc);
        default: return 0;
      }
    });
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

